<template>
  <p class="need-more-ment">
    <span class="visual"></span>
    <span class="text" v-html="$t('journey.targeting.layer.bookmarkGuideForEveryonePlan')" />
  </p>
</template>

<script>
export default {
  name: 'BaBookmarkNeedMore'
}
</script>

<style lang="scss" scoped>
.need-more-ment {
  text-align: center;

  .visual {
    width: 159px;
    height: 89px;
    vertical-align: top;
    background: url('../../assets/img/targeting/img-need-more.svg') no-repeat;
    display: inline-block;
  }
  .text {
    height: 89px;
    font-size: 13px;
    color: #444;
    line-height: 1.77;
    text-align: left;
    vertical-align: top;
    padding: 27px 0 0 25px;
    box-sizing: border-box;
    display: inline-block;
  }
}
</style>
